// extracted by mini-css-extract-plugin
module.exports = {"contents":"Ck-z","sectionHeading":"Dk-z"};